module.exports = __webpack_public_path__ + "/bundle/asset/exam-1-e461fada36abeb4986315ba6889a7f39.png";